import React from 'react';
import { Link } from 'react-router-dom';

const MessageBtn = () => {
    return (
        <Link to='/admin/sms/message' className='border w-10 text-center p-1  bg-gray-100 rounded-md'>
            <i className="fa-regular fa-message"></i>
        </Link>
    )
}

export default MessageBtn;